import axios from "axios";
import { IDM_SERVER_BASE_URL } from "../Constants";
import EventBus from "../Components/CommonComponent/EventBus";
import { COOKIES, SEPERATOR } from "./AuthenticationService";

export const API_URL = IDM_SERVER_BASE_URL + "/v2/api";

class UserService {
    getUsers = async () => {
        const response = await axios.get(`${API_URL}/GetAllUsers`);

        if (response.data.response == null) {
            throw new Error(response.data.errors?.[0]?.message || "Request failed.");
        }

        return response.data.response;
    };

    registerUser = async (registeruserDTO) => {
        const response = await axios.post(`${API_URL}/RegisterUser`, registeruserDTO, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    };

    createRole = async (CreateRoleDTO) => {
        const response = await axios.post(`${API_URL}/CreateRole`, CreateRoleDTO, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    };

    changePassword = async (ChangePasswordDTO) => {
        const response = await axios.post(`${API_URL}/ChangePassword`, ChangePasswordDTO, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    };

    resetUserPassword = async (ResetUserPasswordDTO) => {
        const response = await axios.post(`${API_URL}/ResetUserPassword`, ResetUserPasswordDTO, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    };

    BulkUserDelete = async (bulkDeleteDTO) => {
        var request = {
            request: bulkDeleteDTO,
        };
        const response = await axios.post(
            `${API_URL}/BulkUserDelete`,
            request,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            },
        );
        return response.data;
    };

    getAllRoles = async () => {
        const response = await axios.get(`${API_URL}/GetAllRoles`);

        return response.data;
    };

    updateUserDetails = async (userName, updateUserDTO) => {
        const iDMRequest = {
            Request: updateUserDTO,
        };
        const response = await axios.put(
            `${API_URL}/UpdateUser/${userName}`,
            iDMRequest,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            },
        );
        return response.data;
    };

    GetUsersPerPage = async (searchDTO) => {
        var request = {
            request: searchDTO,
        };
        const response = await axios.post(`${API_URL}/UserSearch`,
            request,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        if (response.status === 401) {
            EventBus.dispatch("Logout");
        }

        if (response.data.errors != null && response.data.errors.length != 0) {
            if (response.data.errors[0].message == "Tenant not selected") {
                EventBus.dispatch("SelectTenant");
            }
        }

        if (response.data.response == null) {
            throw new Error(response.data.errors?.[0]?.message || "Request failed.");
        }

        return response.data.response;
    };
}
export default new UserService();
